<ng-container *ngIf="isModifiable; else elseTemplate">
  <app-date-input class="dlc dlc-color-{{ DLCStatusEnum[dlcStatus] }}" id="{{plat.bonLivraisonPlatId}}_DLC" name="{{plat.bonLivraisonPlatId}}_DLC" [(ngModel)]="plat.livraisonDLC" [calendarInfo]="dateCalendarData" placeholder="DLC/DDM" [disabled]="!isModifiable"></app-date-input>
</ng-container>
<ng-template #elseTemplate>
  <span class="dlc dlc-color-{{ DLCStatusEnum[dlcStatus] }}">{{ plat.livraisonDLC | dateFormat}}</span>
</ng-template>
